import React, { useEffect, useState } from "react";
import FilterDate from "./FilterDate";
import LeagueMatches from "../../../football/league/LeagueMatches";
import CricketLeagueMatches from "../../../cricket/league/CricketLeagueMatches";
import GolfLeagueMatches from "../../../golf/GolfLeagueMatches";
import { loadStyles } from "../../../../utils/cssLoader";
import HorseRacingLeagueMatches from "../../../widgetBoxes/horse-racing/HorseRacingLeagueMatches";

const MatchListing = ({
  sport,
  data,
  difference,
  matchType,
  loadCSS,
  baseUrl,
  setDataId,
  setDataType,
  setHead,
  setDate,
  date,
  isLive,
  dataClient,
  websiteBaseUrl,
  dataPath,
  socketUrl = "",
  channel = "IPUB",
  event = "FootballLiveMatches",
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [clientData, setClientData] = useState([]);
  let [allowedLeagues, setAllowedLeagues] = useState([])
  useEffect(() => {
    const fetchTableData = async () => {
      try {
        const res = await fetch(
          `${baseUrl}/tenant-allow-leagues?sport=${sport}`,
          {
            headers: {
              Token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9",
            },
          }
        );
        if (!res.ok) throw new Error(res.statusText);

        const json = await res.json();
        setAllowedLeagues(json?.data || null);
      } catch (err) {
        console.error("Failed to fetch squad:", err);
      }
    };
    fetchTableData();
  }, [sport]);
  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data?.data;
      setClientData(parsed || []);
    } catch (error) {
      console.error("Failed to parse client data:", error);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("livematchdetail");
    }
  }, [loadCSS]);

  const finalData = dataClient ? clientData : data;

  let sportComponent;
  switch (sport) {
    case "football":
    case "rugby":
      sportComponent = (
        <LeagueMatches
          finalData={finalData}
          difference={difference}
          matchType={matchType}
          loadCSS={loadCSS}
          sport={sport}
          baseUrl={baseUrl}
          setDataId={setDataId}
          setDataType={setDataType}
          setHead={setHead}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          dataClient={dataClient}
          socketUrl={socketUrl}
          channel={channel}
          event={event}
          isLive={isLive}
          allowedLeagues={allowedLeagues}
        />
      );
      break;
    case "tennis":
    case "cricket":
    case "basketball":
    case "icehockey":
      sportComponent = (
        <CricketLeagueMatches
          finalData={finalData}
          difference={difference}
          matchType={matchType}
          loadCSS={loadCSS}
          sport={sport}
          baseUrl={baseUrl}
          setDataId={setDataId}
          setDataType={setDataType}
          setHead={setHead}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          dataClient={dataClient}
          socketUrl={socketUrl}
          allowedLeagues={allowedLeagues}
        />
      );
      break;
    case "golf":
      sportComponent = (
        <GolfLeagueMatches
          data={finalData}
          difference={difference}
          matchType={matchType}
          loadCSS={loadCSS}
          sport={sport}
          baseUrl={baseUrl}
          setDataId={setDataId}
          setDataType={setDataType}
          setHead={setHead}
          type={isLive}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          dataClient={dataClient}
        />
      );
      break;
    case "horseracing":
      sportComponent = (
        <HorseRacingLeagueMatches
          data={finalData}
          difference={difference}
          matchType={matchType}
          loadCSS={loadCSS}
          sport={sport}
          baseUrl={baseUrl}
          setDataId={setDataId}
          setDataType={setDataType}
          setHead={setHead}
          type={isLive}
          websiteBaseUrl={websiteBaseUrl}
          dataPath={dataPath}
          dataClient={dataClient}
        />
      );
      break;

    default:
      sportComponent = <h1>This Sport is currently Not Available</h1>;
  }

  return (
    <>
      <FilterDate
        sport={sport}
        setIsLoading={setIsLoading}
        setDate={setDate}
        date={date}
        // setIsLive={setIsLive}
        isLive={isLive}
        dataClient={dataClient}
        websiteBaseUrl={websiteBaseUrl}
        dataPath={dataPath}
      />
      {sportComponent}
    </>
  );
};

export default MatchListing;
